import { Directive, ElementRef, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


@Directive({
  selector: '[scrolledTo]',
  exportAs: 'scrolledTo',
})
export class ScrolledToDirective {

  reached = false;
  passed = false;
  notreached = true;
  passedChecker = false;

  reachedThree = false;
  reachedEtoro = false;
  reachedBrochure = false;
  reachedBubbles = false;

  passedThree = false;
  passedEtoro = false;
  passedBrochure = false;
  passedBubbles = false;

  notThree = true;
  notBrochure = true;
  notEtoro = true;
  notBubbles = true;

  bubblesDone = false;

  urlAbout = false;
  urlPerf = false;
  urlBrochure = false;

  reachedHowItWorks = false;
  howItWorksDone = false;


  intervalID1;
  intervalID2;

  mobile: Boolean = false;
  constructor(public el: ElementRef, public location: Location, public router: Router) { }



  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }

    const elementPosition = this.el.nativeElement.offsetTop;
    const elementHeight = this.el.nativeElement.clientHeight;
    const scrollPosition = window.scrollY;

    if (scrollPosition >= 800 && scrollPosition <= 1850) {
      this.reachedThree = true;
      if (this.urlAbout == false) {
        // this.location.replaceState('/#about');
        this.urlAbout = true;
      }
    } else {
      this.reachedThree = false;
      // console.log(this.router.url)
      // this.location.replaceState("/");
    }

    if (scrollPosition >= 1850 && scrollPosition <= 5100) {
      this.reachedEtoro = true;
      if (this.urlPerf == false) {
        // this.location.replaceState("/#performance");
        this.urlPerf = true;
      }
    } else {
      this.reachedEtoro = false;
      // console.log(this.router.url)
    }

    // console.log(scrollPosition)


    if (this.bubblesDone == false) {
      if (scrollPosition >= 4573 && scrollPosition <= 4700) {
        let count = 0; // track the number of cycles
        const maxCycles = 4; // define the number of cycles

        this.intervalID1 = setInterval(() => {
          this.reachedBubbles = true;

          // Remove the class after 1 second
          setTimeout(() => {
            this.reachedBubbles = false;
          }, 1000);

          count++;

          // Stop the interval after the specified number of cycles
          if (count === maxCycles) {
            clearInterval(this.intervalID1);
          }

        }, 2000);
        this.bubblesDone = true;
      }

    }

    if (this.howItWorksDone == false) {
      if (scrollPosition >= 670 && scrollPosition <= 1100) {
        let count = 0; // track the number of cycles
        const maxCycles = 4; // define the number of cycles

        this.intervalID2 = setInterval(() => {
          this.reachedHowItWorks = true;

          // Remove the class after 1 second
          setTimeout(() => {
            this.reachedHowItWorks = false;
          }, 1000);

          count++;

          // Stop the interval after the specified number of cycles
          if (count === maxCycles) {
            clearInterval(this.intervalID2);
          }

        }, 2000);
        this.howItWorksDone = true;
      }

    }


    if (scrollPosition >= 6400) {
      this.reachedBrochure = true;
      if (this.urlBrochure == false) {
        // this.location.replaceState("/#brochure");
        this.urlBrochure = true;
      }
    } else {
      this.reachedBrochure = false;
      // this.location.replaceState("/");
    }

    // set `true` when scrolling has reached current element
    this.reached = scrollPosition >= elementPosition;

    // set `true` when scrolling has passed current element height
    this.passed = scrollPosition >= (elementPosition + elementHeight);

    if (this.passed == true) {
      // console.log("passed");
    }

    if (this.reached == true) {
      // console.log("reached")
      this.notreached = false;
    } else if (this.reached == false) {
      this.notreached = true;
    }

    // if(!this.reachedBubbles && !this.reachedBrochure && !this.reachedEtoro && !this.reachedThree){
    //   this.location.replaceState("/");
    //   console.log("here!!")
    // }

    if (this.mobile) {
      if (this.bubblesDone == false) {
        if (scrollPosition >= 3680 && scrollPosition <= 4200) {
          let count = 0; // track the number of cycles
        const maxCycles = 4; // define the number of cycles

        this.intervalID1 = setInterval(() => {
          this.reachedBubbles = true;

          // Remove the class after 1 second
          setTimeout(() => {
            this.reachedBubbles = false;
          }, 1000);

          count++;

          // Stop the interval after the specified number of cycles
          if (count === maxCycles) {
            clearInterval(this.intervalID1);
          }

        }, 2000);
        this.bubblesDone = true;
        }
      }

      if (this.howItWorksDone == false) {
      if (scrollPosition >= 508 && scrollPosition <= 981) {
        let count = 0; // track the number of cycles
        const maxCycles = 4; // define the number of cycles

        this.intervalID2 = setInterval(() => {
          this.reachedHowItWorks = true;

          // Remove the class after 1 second
          setTimeout(() => {
            this.reachedHowItWorks = false;
          }, 1000);

          count++;

          // Stop the interval after the specified number of cycles
          if (count === maxCycles) {
            clearInterval(this.intervalID2);
          }

        }, 2000);
        this.howItWorksDone = true;
      }

    }
    }
  }
}
